var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "shop-checkout__button" }, [
    _c("div", { staticClass: "button-wrapper--order-btn" }, [
      _c(
        "button",
        {
          class: ["button", "button--primary"],
          attrs: { disabled: _vm.isOrderingDisabled },
          on: { click: _vm.order },
        },
        [_vm._t("button-label")],
        2
      ),
      _vm._v(" "),
      _c("p", {
        staticClass: "error",
        domProps: { innerHTML: _vm._s(_vm.replacedErrorText) },
      }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }